import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { InventoryAuthority, inventoryFirestorePath } from '@qkindex/contracts';
import { Item } from '../domain/item';
import { db } from '../firebase';
import { DocumentLike, mapItemDocument } from './mappers';

interface SnapshotLike {
  docs: DocumentLike[];
}
type Listen = (
  next: (snapshot: SnapshotLike) => void,
  error: (error: Error) => void,
) => () => void;

export const createDeletedItemSubscriber =
  (listen: Listen) =>
  (
    onItems: (items: Item[]) => void,
    onError: (error: Error) => void,
  ): (() => void) =>
    listen(
      (snapshot) =>
        onItems(
          snapshot.docs
            .map(mapItemDocument)
            .filter(
              (item): item is Item => item !== null && item.deleted === true,
            ),
        ),
      onError,
    );

export const subscribeToDeletedItems = (
  authority: InventoryAuthority,
  onItems: (items: Item[]) => void,
  onError: (error: Error) => void,
): (() => void) =>
  createDeletedItemSubscriber((next, error) =>
    onSnapshot(
      query(
        collection(db, inventoryFirestorePath(authority, 'items')),
        where('deleted', '==', true),
      ),
      next,
      error,
    ),
  )(
    (items) =>
      onItems(
        items.map((item) => ({
          ...item,
          collectionId: authority.collectionId,
        })),
      ),
    onError,
  );
